import { Box, Typography, useTheme } from "@mui/material";
import AppLogomark from "./AppLogomark";

const BRAND_TEXT = "Service Tools";

const variantConfig = {
  navbar: {
    logomarkSize: 30,
    titleVariant: { xs: "h5", md: "h4" },
    gap: 1,
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
  },
  hero: {
    logomarkSize: 48,
    titleVariant: "h3",
    gap: 1.5,
    textShadow: "none",
  },
  compact: {
    logomarkSize: 26,
    titleVariant: "h6",
    gap: 1,
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
  },
};

const AppBrand = ({ variant = "navbar", href, subtitle, sx = {} }) => {
  const theme = useTheme();
  const config = variantConfig[variant] ?? variantConfig.navbar;
  const isHero = variant === "hero";

  const logomarkColor = isHero ? theme.palette.primary.main : "currentColor";
  const accentColor = isHero
    ? theme.palette.primary.dark
    : "rgba(255, 255, 255, 0.85)";

  const title = (
    <Typography
      variant={config.titleVariant}
      component={isHero ? "h1" : "span"}
      sx={{
        fontFamily: theme.typography.brand?.fontFamily ?? "Rajdhani, sans-serif",
        fontWeight: theme.typography.brand?.fontWeight ?? 700,
        letterSpacing: theme.typography.brand?.letterSpacing ?? "0.1em",
        textTransform: theme.typography.brand?.textTransform ?? "uppercase",
        lineHeight: 1.1,
        textShadow: config.textShadow,
        whiteSpace: "nowrap",
      }}
    >
      <Box component="span" sx={{ opacity: 1 }}>
        Service
      </Box>{" "}
      <Box component="span" sx={{ opacity: 0.85 }}>
        Tools
      </Box>
    </Typography>
  );

  const content = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: config.gap,
        color: "inherit",
        ...sx,
      }}
    >
      <AppLogomark
        size={config.logomarkSize}
        color={logomarkColor}
        accentColor={accentColor}
      />
      {subtitle ? (
        <Box
          sx={{ display: "flex", flexDirection: "column", textAlign: "left" }}
        >
          {title}
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        </Box>
      ) : (
        title
      )}
    </Box>
  );

  if (href) {
    return (
      <Box
        component="a"
        href={href}
        aria-label={`${BRAND_TEXT} home`}
        sx={{
          mr: 2,
          color: "inherit",
          textDecoration: "none",
          ...sx,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default AppBrand;
